'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes2.default.ADD_LOCATION:
      {
        var historyAction = action.location.action;

        if (historyAction === historyActions.POP) {
          return _extends({}, state, {
            activeLocation: action.location
          });
        }

        return {
          previousLocation: state.activeLocation,
          activeLocation: action.location
        };
      }

    default:
      return state;
  }
};

var _actionTypes = require('../actionTypes');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var initialState = {
  previousLocation: null,
  activeLocation: null
};
var historyActions = {
  POP: 'POP',
  PUSH: 'PUSH',
  REPLACE: 'REPLACE'
};